import { render, staticRenderFns } from "./Fidc.vue?vue&type=template&id=19bfeefb&scoped=true&"
import script from "./Fidc.vue?vue&type=script&lang=js&"
export * from "./Fidc.vue?vue&type=script&lang=js&"
import style0 from "./Fidc.vue?vue&type=style&index=0&id=19bfeefb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfeefb",
  null
  
)

export default component.exports